module.exports = __webpack_public_path__ + "static/media/YSM.f2bf0288.gif";


//////////////////
// WEBPACK FOOTER
// ./src/icons/YSM.gif
// module id = 1441
// module chunks = 0